import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 30,
	viewBox: "0 0 25 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.17006 22.428C3.51817 21.1924 3.14844 19.7718 3.14844 18.2734C3.14844 13.3015 7.17655 9.27344 12.1484 9.27344C17.1203 9.27344 21.1484 13.3015 21.1484 18.2734C21.1484 19.7816 20.7787 21.2118 20.117 22.4572",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.17006 22.428C3.51817 21.1924 3.14844 19.7718 3.14844 18.2734C3.14844 13.3015 7.17655 9.27344 12.1484 9.27344C17.1203 9.27344 21.1484 13.3015 21.1484 18.2734C21.1484 19.7816 20.7787 21.2118 20.117 22.4572",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.4161 17.647C15.4161 19.4674 13.9401 20.9425 12.1207 20.9425C10.3002 20.9425 8.82422 19.4674 8.82422 17.647C8.82422 15.8266 10.3002 14.3516 12.1207 14.3516C13.9401 14.3516 15.4161 15.8266 15.4161 17.647Z",
			fill: "white",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 26.6986C7.20433 25.1126 8.61514 23.3516 12.1178 23.3516C15.6594 23.3516 17.0605 25.1224 17.2551 26.7278",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgProfile;
